import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import superadminapi, { getProfile } from '../../../Base/SuperAdminConfig';
import Sidebar from "../Sidebar/Sidebar";
import styles from "./layout.module.css";

export default function Layout({ children }) {
    const location = useLocation().pathname;
    const [showMenu, setShowMenu] = useState(false);
    const [email, setEmail] = useState(false);
    const [loading, setLoading] = useState(true);

    const handleShowMenu = () => {
        setShowMenu(!showMenu);
    };

    const fetchUsersCount = () => {
        superadminapi.get(getProfile)
        .then((res) => {
            if(res.data.code === 200){
                setLoading(false);
                setEmail(res?.data?.result?.email);
            } else {
                setEmail('');
            }
        })
        .catch((error) => {
            setLoading(false);
            console.log(error);
        })
    }

    useEffect(() => {
        fetchUsersCount();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const pageTitle = () => {
        const path = location.split("/");
        const page = path[path.length - 1];
        switch (page) {
            case "dashboard":
                return "Dashboard";
            case "clients":
                return "Clients";
            case "client-details":
                return "Client Details";
            case "plans":
                return "Plans";
            case "test-apis":
                return "Test APIs";
            case "apis":
                return "APIs";
            default:
                return "";
        }
    }

    return (<>
        <div className={styles["dashboard-layout"]}>
            <div className={styles["dashboard-navbar"]}>
                <div className={styles["dashboard-logo"]}>
                    <img src="../images/logo-light.png" alt="" />
                    <div className={styles["menubar"]} onClick={() => setShowMenu(!showMenu)}>
                        <i className={showMenu ? "fa fa-times" : "fa fa-bars"} aria-hidden="true"></i>
                    </div>
                </div>
                <div className={styles["page-header"]}>
                    <div className={styles["page-title"]}>{pageTitle()}</div>
                    {!loading && <div className={styles["user-details"]}>
                        <img src="../../images/superadmin/user-id-icon.svg" alt="" />
                        <p><span>User</span> {email}</p>
                    </div>}
                </div>
            </div>
            <div className={styles["dashboard-body"]}>
                <div className="max-md:hidden">
                    <Sidebar handleShowMenu={handleShowMenu} />
                </div>
                {showMenu && (
                    <div className="hidden max-md:block absolute left-0 top-0 w-full h-screen grid justify-items-center items-center">
                        <div className="absolute left-0 top-0 bg-[#00000060] z-[999] w-full h-screen" data-testid="background" onClick={() => setShowMenu(false)}></div>
                        <div className="text-center absolute z-[9999] bg-white w-full h-full">
                            <div className="p-[20px] flex justify-between">
                                <img src="../images/logo-dark.png" alt="" className="w-[200px]" />
                                <div className={styles["menubar"]} onClick={() => setShowMenu(!showMenu)}>
                                    <i className={showMenu ? "fa fa-times" : "fa fa-bars"} aria-hidden="true"></i>
                                </div>
                            </div>
                            <Sidebar handleShowMenu={handleShowMenu} />
                        </div>
                    </div>
                )}
                <div className={styles["dashboard-content"]}>{children}</div>
            </div>
        </div>
    </>);
}